module.exports = __webpack_public_path__ + "media/icons/theme-switch-icon-blue-4847eb85.svg";